import { ApolloLink } from '@apollo/client'

type MutationListener = (operationName: string) => void

const listeners = new Set<MutationListener>()

/** Subscribe to successful mutations app-wide; returns an unsubscribe function */
export const onMutationCompleted = (listener: MutationListener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

// Never throws: a request it cannot classify passes through untouched
const isMutation = (operation: Parameters<ApolloLink['request']>[0]) =>
  !!operation.query?.definitions?.some(
    (definition) =>
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation'
  )

/** Notifies listeners when a mutation returns without GraphQL errors */
export const mutationEventsLink = new ApolloLink((operation, forward) => {
  if (!isMutation(operation)) return forward(operation)

  return forward(operation).map((result) => {
    if (!result.errors?.length) {
      listeners.forEach((listener) => listener(operation.operationName))
    }
    return result
  })
})
